"use strict";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import {i18n} from './plugins/i18n.js'

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap';

// CSS and fonts
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
require("@/assets/css/fonts.css");
require("@/assets/css/baloon.css");
// import "../static/js/NeverBounce.js";


// Layouts
import Adminlayout from './layouts/Adminlayout.vue';
import Generic from './layouts/Generic.vue';
import Landing from './layouts/Landing.vue';
import Result from './layouts/Result.vue';
import Survey from './layouts/Survey.vue';
import Print from './layouts/Print.vue';

Vue.component('adminlayout-layout', Adminlayout);
Vue.component('print-layout', Print);
Vue.component('generic-layout', Generic);
Vue.component('landing-layout', Landing);
Vue.component('result-layout', Result);
Vue.component('survey-layout', Survey);

// Custom Filters
import './filters/TranslateGrader.js';


// Stores (and login)
import Vuex from 'vuex'
Vue.use(Vuex)

import store from './store/index.js';
import './auth';

// Routes
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import router from './router';

// Responsive helper
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: Infinity,
  }
})

// Error tracking
import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://1174685dd0b64827a3db2e602bfcc4f7@sentry.io/1370484',
  integrations: [new Sentry.Integrations.Vue({ Vue })]
})

//

Vue.config.productionTip = false

// Launch App
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store, //inject store in all children components
  i18n,
  components: { App },
  template: '<App/>',
  router
}).$mount('#app')

window.Vue = Vue;







// WEBPACK FOOTER //
// ./src/main.js